import type {
  KundaliRequest,
  RemedyDoshaInfo,
  RemedyEnrichedProduct,
  RemedyBundle,
  ChartRemedyResponse,
  DoshaProductsResponse,
  ProductRecommendation,
} from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type {
  RemedyDoshaInfo,
  RemedyBundle,
  ChartRemedyResponse,
  DoshaProductsResponse,
  ProductRecommendation,
};

// EnrichedProduct: ProductDetail + web-only fields (compare_at_price, type).
export type EnrichedProduct = RemedyEnrichedProduct;

export async function getRemediesForChart(data: KundaliRequest): Promise<ChartRemedyResponse> {
  return apiRequest<ChartRemedyResponse>("/remedies/for-chart", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function getRemediesForDosha(doshaId: string): Promise<DoshaProductsResponse> {
  return apiRequest<DoshaProductsResponse>(`/remedies/for-dosha/${doshaId}`);
}
